import React, { useEffect, useState } from "react";
import Select, { StylesConfig } from "react-select";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../utils/firebase-config";
import { getBanks } from "../BankScrapAutoComplete/banks-service";

const BankAutocomplete: React.FC<{
  label: string;
  placeholder: string;
  onChange: (banksStorage : any) => void;
  countryConfigEntity: any;
  initialValue?: any;
  isDisabled?: boolean;
}> = ({
  label,
  placeholder,
  onChange,
  countryConfigEntity,
  initialValue,
  isDisabled,
}) => {

    const [storageOptions, setStorageOptions] = useState<any[]>([]);
    const [selectedStorage, setSelectedStorage] = useState<any>(
      initialValue || null
    );
    const [inputValue, setInputValue] = useState("");
    const [userId, setUserId] = useState<string>();

    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          setUserId(user.uid);
        } else {
          setUserId("");
        }
      });
      return () => unsubscribe();
    }, []);

    const handleChangeRef = React.useRef(onChange);
    handleChangeRef.current = onChange;



    useEffect(() => {
      const fetchData = async () => {
        try {
            const banksStorage = await getBanks(
                countryConfigEntity.country[0]
              );

          const options = banksStorage.map((storage) => ({
            value: storage.code,
            label: storage.name,
            data: storage,
          }));



          setStorageOptions(options);

          if (initialValue) {
            const initialStorage = options.find(
              (option) => option.value === initialValue.code
            );
            if (initialStorage) {
              setSelectedStorage(initialStorage.data);
              handleChangeRef.current(initialStorage.data);
            }
          }
        } catch (error) {
          console.error("Error fetching storages:", error);
        }
      };

      fetchData();
    }, [initialValue]);

    const handleChange = (selectedOption: any) => {
      if (selectedOption && selectedOption.data) {
        setSelectedStorage(selectedOption.data);
        handleChangeRef.current(selectedOption.data);
      } else {
        setSelectedStorage(null);
        handleChangeRef.current(null);
      }
    };

    const handleInputChange = (newValue: string) => {
      setInputValue(newValue);
    };

    const customFilterOptions = (candidate: any, input: string) => {
      return candidate?.label?.toLowerCase().includes(input?.toLowerCase());
    };

    const customStyles: StylesConfig<any, false> = {
      option: (provided) => ({
        ...provided,
      }),
    };

    return (
      <div className="flex-column select-field">
        <div className="flex-row justify-between">
          <label htmlFor="banksStorage">{label}</label>
        </div>
        <div >
          <Select
            id="banksStorage"
            placeholder={placeholder}
            value={
              selectedStorage
                ? { value: selectedStorage.code, label: `${selectedStorage.name}` }
                : null
            }
            onChange={handleChange}
            onInputChange={(newValue, { action }) => {
              if (action === "input-change") {
                handleInputChange(newValue);
              }
            }}
            options={storageOptions}
            filterOption={customFilterOptions}
            isDisabled={isDisabled}
            styles={customStyles}
          />
        </div>
      </div>
    );
  };

export default BankAutocomplete;
